import React from 'react'
 
const design = props => {
  return (
      <img src={props.src} alt="img"  style={{maxWidth:'100%'}}/>
  )
}
 
export default design
 